<script>
import Constants from '../constants';

export default {
  name: 'commonParallaxItem',
  components: {
  },
  props: {
    isReturn: { // 一回出てまた上にスクロールされた場合に消える
      type: Boolean,
      default: true,
    },
    showPercentage: { // どのくらいスクロールされると表示されるか
      type: Number,
      default: 3,
    },
    parallaxPattern: { // move, blur
      type: String,
      default: 'move',
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  created() {
    setTimeout(()=> {
      window.addEventListener('scroll', this.onscroll);
      window.addEventListener('resize', this.onscroll);
      this.onscroll();
    }, 1);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onscroll);
    window.removeEventListener('resize', this.onscroll);
  },
  methods: {
    onscroll() {
      if (!this.$el) { return; }
      const top = this.$el.getBoundingClientRect().top;
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      const windowHeight = window.innerHeight < minHeight  ? minHeight : window.innerHeight;
      this.isShow = windowHeight - (windowHeight / this.showPercentage) - top > 0;
      if (this.isShow && !this.isReturn) {
        window.removeEventListener('scroll', this.onscroll);
        window.removeEventListener('resize', this.onscroll);
      }
    },
  },
};
</script>

<template>
  <div class="common-parallax-item" :class="[this.isShow ? 'is-show' : '', parallaxPattern]">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  // @import "../css/variables";
  .common-parallax-item {
    transition: 0.5s ease-in-out;
    opacity: 0;
    &.is-show {
      opacity: 1;
    }
    // move
    &.move {
      transform: translate(0, 50px);
      &.is-show {
        transform: translate(0, 0);
      }
    }
    // blur
    &.blur {
      filter: blur(20px);
      &.is-show {
        filter: blur(0px);
      }
    }
  }
</style>
